import { Link } from "gatsby";
import { MouseEventHandler, PropsWithChildren } from "react";
import { buttonLink, buttonLinkLoading } from "./styles.css";
import classNames from "classnames";

type ButtonLinkProps = {
  to?: string;
  isExternal?: boolean;
  onClick?: MouseEventHandler;
  isLoading?: boolean;
};

export const ButtonLink = ({
  to,
  isExternal,
  children,
  isLoading,
  className: _className,
  onClick,
}: PropsWithChildren<ButtonLinkProps & StyledProps>) => {
  const className = classNames(buttonLink, _className, {
    [buttonLinkLoading]: isLoading,
  });

  if (!to) {
    return (
      <button className={className} onClick={onClick}>
        {children}
      </button>
    );
  }

  if (to.startsWith("mailto:")) {
    return (
      <a className={className} href={to} onClick={onClick}>
        {children}
      </a>
    );
  }

  return isExternal ? (
    <a className={className} href={to} target="_blank" onClick={onClick}>
      {children}
    </a>
  ) : (
    <Link
      className={className}
      to={to}
      onClick={onClick}
      state={{ type: "button-link" }}
    >
      {children}
    </Link>
  );
};
